/* eslint-disable @typescript-eslint/no-explicit-any */
import { SerializedError } from '@reduxjs/toolkit';
import { FetchBaseQueryError } from '@reduxjs/toolkit/query';

/**
 * @param error - The error object to be handled.
 * Logs the error message to the console in development mode.
 * In production, this function can be extended to report errors to an external service.
 */
export function handleError(error: unknown, fileName: string): void {
  if (process.env.NODE_ENV === 'development') {
    error instanceof Error
      ? console.error(`Error occurred in ${fileName}:`, error.message)
      : console.error(`Error occurred in ${fileName}:`, String(error));
  }
  // TODO: Implement error reporting service integration here for production and quality
}

export type ApiResponse =
  | {
      data: any;
      error?: undefined;
    }
  | {
      data?: undefined;
      error: FetchBaseQueryError | SerializedError;
    };
export function handleResponse(response: ApiResponse): void {
  if (process.env.NODE_ENV === 'development') {
    console.log('Response From API:', response.data);
  }
}
